import { useCallback, useState } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { MessageBox } from 'components';
import { MeasurementDateDialog } from 'components/MeasurementDates';
import { useGetCompanyInfoById } from 'services/hooks/company';
import { useRefreshFirmMeasurementDates } from 'services/hooks/firms';
import { MissingMeasurementDateMessageProps } from './MissingMeasurementDateMessage.props';

const MissingMeasurementDateMessage = ({ title, tagline }: MissingMeasurementDateMessageProps) => {
  const [{ companyInfo }] = useStore() as unknown as UseStoreValues;
  const getCompanyInfo = useGetCompanyInfoById();
  const { refreshFirmMeasurementDates } = useRefreshFirmMeasurementDates();
  const [openMeasurementDatesDialog, setOpenMeasurementDatesDialog] = useState(false);

  const handleOpenMeasurementDatesDialog = useCallback(() => {
    setOpenMeasurementDatesDialog(true);
  }, []);

  const handleMeasurementDatesRefresh = useCallback(async () => {
    if (!companyInfo?.id) {
      return;
    }

    await refreshFirmMeasurementDates({ companyId: companyInfo.id });
    await getCompanyInfo(companyInfo.id);
  }, [companyInfo?.id, getCompanyInfo, refreshFirmMeasurementDates]);

  return (
    <>
      <MessageBox
        title={title}
        tagline={tagline}
        fullWidth={false}
        action={
          <Button
            id="add-md-btn"
            variant="outlined"
            color="primary"
            onClick={handleOpenMeasurementDatesDialog}
            endIcon={<AddIcon />}>
            Add Measurement Date
          </Button>
        }
      />
      {openMeasurementDatesDialog && companyInfo && (
        <MeasurementDateDialog
          open={openMeasurementDatesDialog}
          activeCompany={companyInfo}
          onClose={() => setOpenMeasurementDatesDialog(false)}
          getMeasurementDates={handleMeasurementDatesRefresh}
        />
      )}
    </>
  );
};

export default MissingMeasurementDateMessage;
